import { Component } from "react";
import { connect } from "react-redux";
import { validate } from "../../../redux/absences/absencesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import RefuseAbsenceModal from "../RefuseAbsenceModal";
import FooterFixedOnScreen from "../../../containers/Layout/FooterFixedOnScreen";

class AbsenceToValidate extends Component {
    validate() {
        this.props.validate(this.props.absences, this.props.activeUser);
    }

    render() {
        return (
            <FooterFixedOnScreen>
                <div className="row">
                    <div className="col-lg-1 col-md-2 col-sm-4 col-6">
                        <Fab onClick={this.validate.bind(this)} className="div-center green-button">
                            <Icon>check</Icon>
                        </Fab>
                        <span className="floating-btn-text span-center">Valider</span>
                    </div>
                    <div className="offset-lg-10 col-lg-1 offset-md-8 col-md-2 offset-sm-4 col-sm-4 col-6">
                        <div className="center">
                            <RefuseAbsenceModal />
                        </div>
                    </div>
                </div>
            </FooterFixedOnScreen>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        validate: (absencesState, activeUser) => dispatch(validate(absencesState, activeUser)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AbsenceToValidate);
